var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"splash-page",attrs:{"fluid":""}},[_c('v-row',{staticClass:"text-center h-100",attrs:{"align":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('img',{staticClass:"logo",attrs:{"src":'/image/logo.png'}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }